var _circle, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcon3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 33,
    viewBox: "0 0 33 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16.5,
    cy: 16.5,
    r: 16.5,
    fill: "#008FDF"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2460_2101)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.8225 19.5978L14.638 13.3813H18.8007L17.5532 14.6353L21.4137 18.5155L22.2804 19.3732C22.7072 18.5087 22.9436 17.5321 22.9436 16.5027C22.9436 12.9128 20.0482 10.0027 16.4764 10.0027C14.579 10.0027 12.8719 10.8276 11.6835 12.1341L11.9329 12.3389L18.8007 19.2414H14.638L15.8855 17.9874L11.8801 13.9623L10.9872 13.0577C10.3634 14.0546 10.0089 15.2292 10.0089 16.4962C10.0089 20.0861 12.9044 22.9962 16.4764 22.9962C18.5835 22.9962 20.455 21.98 21.6369 20.416L20.8227 19.5978H20.8225Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2460_2101"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 13,
    height: 13,
    fill: "white",
    transform: "translate(10 10)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon3);
export default __webpack_public_path__ + "static/media/icon3.a90a999fdd21839a571b389e0b961b50.svg";
export { ForwardRef as ReactComponent };